import { TypeChecker } from '@attain-apps/type-guards'

import { Expression } from '../../../expression'

export namespace CommonArgs {
  export const isListOfExpressions = TypeChecker.Factory.lazy(() =>
    TypeChecker.Factory.list(Expression.isExpression),
  )
  export const isTwoExpressions = TypeChecker.Factory.lazy(() =>
    TypeChecker.Factory.tuple(Expression.isExpression, Expression.isExpression),
  )
  export const isExpressionOrListOfExpressions = TypeChecker.Factory.lazy(() =>
    TypeChecker.Factory.union(Expression.isExpression, isListOfExpressions),
  )
  export const isExpressionOrTwoExpressions = TypeChecker.Factory.lazy(() =>
    TypeChecker.Factory.union(Expression.isExpression, isTwoExpressions),
  )
}
